import React from 'react';

import Icon from '../Icon/Icon';

const OutsideLink = (props) => {
    return (
        <Icon width='25' height='26' {...props}>
            <g stroke='#34303D' fill='none' fillRule='evenodd'>
                <path
                    d='M19.913 16.256v3.725a1 1 0 0 1-1 1H5.019a1 1 0 0 1-1-1V6.087a1 1 0 0 1 1-1h3.776'
                    strokeLinecap='round'
                />
                <path d='M19.913 5.125 9.769 15.23' />
                <path strokeLinecap='round' d='M19.916 12.637V5.212H12.49' />
            </g>
        </Icon>
    );
};

export default OutsideLink;
